import { useT } from '@repo/ui/hooks'

import { PromptEditorLight } from '@/components/admin/PromptEditorLight'
import { adminStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { Organization } from '@/store/user'

export function BeneficiaryProfileTemplateRoute({ organization }: { organization: Organization }) {
  const { tc, t } = useT({ keyPrefix: 'admin.beneficiaryProfileTemplate' })
  const dispatch = useStoreDispatch()
  const handleUpdate = (beneficiaryProfileTemplate: string) => {
    void dispatch(
      adminStoreActions.organization.update({
        fields: { beneficiaryProfileTemplate },
      }),
    )
  }
  return (
    <PromptEditorLight
      key="beneficiaryProfileTemplate"
      initialPrompt={organization.beneficiaryProfileTemplate ?? ''}
      description={t('description')}
      onPromptUpdated={handleUpdate}
      placeholder={t('placeholder')}
      title={tc('beneficiaryProfileTemplate', { cfl: true })}
    />
  )
}
